const ADDRESS_BASED_ORDERING_TYPES = new Set([
  "MULTI_REGION",
  "CURRENT_REGION",
]);

function hasAddressBasedOrderingType(checkArguments: unknown): boolean {
  if (
    !checkArguments ||
    typeof checkArguments !== "object" ||
    Array.isArray(checkArguments)
  ) {
    return false;
  }

  const orderingType = (checkArguments as { ordering_type?: unknown })
    .ordering_type;
  return (
    typeof orderingType === "string" &&
    ADDRESS_BASED_ORDERING_TYPES.has(orderingType)
  );
}

export function isAddressBasedCriminalCheck(
  checkType: string,
  checkArguments: unknown
): boolean {
  return (
    checkType?.includes("CRIMINAL_RECORD_REPORT") &&
    hasAddressBasedOrderingType(checkArguments)
  );
}

export function isAddressBasedCreditCheck(
  checkType: string,
  checkArguments: unknown
): boolean {
  return (
    checkType === "CREDIT_REPORT_1" &&
    hasAddressBasedOrderingType(checkArguments)
  );
}

export function isAddressBasedCheck(
  checkType: string,
  checkArguments: unknown
): boolean {
  return (
    isAddressBasedCriminalCheck(checkType, checkArguments) ||
    isAddressBasedCreditCheck(checkType, checkArguments)
  );
}
